var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/education/bookmark_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 3.33337C2.66699 2.22881 3.56243 1.33337 4.66699 1.33337H11.3337C12.4383 1.33337 13.3337 2.22881 13.3337 3.33337V14.019C13.3337 14.8324 12.4143 15.3054 11.7524 14.8327L8.00033 12.1526L4.24823 14.8327C3.58637 15.3054 2.66699 14.8324 2.66699 14.019V3.33337ZM4.66699 2.66671C4.29881 2.66671 4.00033 2.96519 4.00033 3.33337V13.3712L7.41906 10.9293C7.76679 10.6809 8.23386 10.6809 8.58159 10.9293L12.0003 13.3712V3.33337C12.0003 2.96519 11.7019 2.66671 11.3337 2.66671H4.66699Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkLine);
export default __webpack_public_path__ + "static/media/bookmark_line.afbfdf48e6e06167bf037e8495561ce6.svg";
export { ForwardRef as ReactComponent };